module.exports = __webpack_public_path__ + "img/Photoshop-icon.9da6c5f9.svg";